<template>
  <v-container id="status" fluid :class="{'hs-status__sm px-1': $vuetify.breakpoint.smAndDown }">
    <v-layout v-if="!isError" wrap>
      <v-flex xs12>
        <v-container fluid>
          <v-layout>
            <v-flex class="hs-status">
              <v-content class="justify-start hs-status__info">
                Below you will see any current <span class="font-weight-bold">HawkSoft Alerts</span> along with a status of <span class="font-weight-bold">HawkSoft systems and services</span>.
                For updates on anything related to our hosting partners or other updates, please see our <span><a href="https://www.hawksoft.com/support/" target="_blank">HawkSoft Support Page</a></span>.
              </v-content>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex id="hs-alerts" xs12>
        <Alerts />
      </v-flex>
      <v-flex xs12>
        <SystemStatus />
      </v-flex>
    </v-layout>
    <v-layout v-else>
      <v-flex :class="{'offset-xs4 xs4': !$vuetify.breakpoint.smAndDown }" text-xs-center>
        <v-icon color="amber" class="xx-large">warning</v-icon>
        <div :class="$vuetify.breakpoint.smAndDown ? 'title pb-2' : 'headline'">There was an error loading this page</div>
        <div class="subheading-1">If the issue persists, please contact HawkSoft Professional Services</div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { statusHandler } from '@/services/api';
import { formatTime } from '@/filters/filters.js';
import Alerts from '@/components/Alerts.vue';
import SystemStatus from '@/components/SystemStatus.vue';

export default {
  filters: { formatTime },
  components: {
    Alerts,
    SystemStatus
  },
  data: function () {
    return {
      isError: false
    };
  },
  async mounted () {
    await this.getAlerts();
  },
  methods: {
    ...mapActions(['setAlerts', 'setSystemStatus']),
    async getAlerts () {
      try {
        const result = await statusHandler.getAlerts();

        if (!result) {
          this.isError = true;
        } else {
          this.setAlerts(result.alerts);
        }
      } catch (ex) {
        this.isError = true;
      }
    }
  }
};
</script>

<style scoped>
  #status {
    max-width: 1280px !important;
  }
  .hs-status {
    /* max-width:75vw; */
  }
  .hs-status__info {
    font-size: 18px !important;
    padding: 0 !important;
  }
  .label {
    font-size: 12px;
    color: rgba(0,0,0, .54);
  }
  .xx-large {
    font-size: 10em;
  }
  /* Tablet and Mobile */
  @media screen and (max-width: 650px) {
    .hs-status {
      max-width: 100% !important;
    }
    .container {
      padding: 16px 6px !important;
    }
  }
</style>
